export const CONTENT_SECTION_IDS = {
  location: 'getting-there',
  highlights: 'highlights',
  facilities: 'facilities',
  facilitiesAll: 'facilities-all',
  itinerary: 'itinerary',
  finePrint: 'fine-print',
  finePrintSafety: 'fine-print-safety',
  customerReviews: 'customer-reviews',
} as const
